export default __webpack_public_path__ + "static/media/blog-img236.5c06618b.jpg";